<template>
	<div class="import-shop-products">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Brand Price Adjustment</h1>

		<p class="description">
			This page will adjust the price of each brands for each shop.
		</p>

		<div class="content-wrapper">
			<div class="single-text-wrapper">
				<b-field label="Name">
					<b-input v-model="name" placeholder="Special Price Increment"></b-input>
				</b-field>
			</div>

			<b-field label="Select Brand" v-if="!edit">
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand"
					field="code"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>
			<b-field v-else> {{ selectedBrand.code }} ( {{ selectedBrand.name }} )</b-field>

			<b-field label="Select Shop" v-if="!edit">
				<b-select v-model="shops" :data="filteredShops" multiple native-size="8" class="shopAutoComplete">
					<option v-for="shop in filteredShops" :value="shop" :key="shop._id">
						{{ shop.name }}
					</option>
				</b-select>
			</b-field>
			<b-field v-else>
				<div v-for="(item, key) of shops" :key="key" class="autoid-wrapper">
					<span>{{ item.name }}({{ item.shop_id }})</span>
				</div>
			</b-field>

			<b-radio v-model="type" name="type" native-value="fixed">Fixed Amount</b-radio>
			<b-radio v-model="type" name="type" native-value="percentage">Percentage</b-radio>

			<div class="single-text-wrapper">
				<b-field label="Value">
					<b-input v-model="value" placeholder="2500"></b-input>
				</b-field>
			</div>

			<b-checkbox v-model="status">
				Enable
			</b-checkbox>

			<div class="button-container">
				<div class="big-button" @click="submit()">
					Adjust Price
				</div>
			</div>
			<br />
			<br />
			<div v-if="processCount > 0">Updating {{ processCount }} of {{ total }}</div>
			<div v-if="failCount > 0">{{ failCount }} FAILED</div>
			<br />
			<br />
			<div v-if="updateResult.length > 0">
				<div v-for="(data, index) of updateResult" v-bind:key="index">{{ data }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'BrandPriceAdjustment',
	data: () => ({
		isLoading: false,
		file: null,
		fileUpload: null,
		name: '',
		brands: [], // To store brands
		selectedBrand: '',
		brandSuggestions: '',
		type: '',
		value: '',
		status: true,

		edit: false,

		shops: [],
		shopList: [],
		shopsSuggestions: '',
		selectedShop: [],

		products: [],
		totalLoop: 0,
		total: 0,
		totalCount: 0,
		loopCount: 0,
		limit: 100,
		updateResult: [],
		processCount: 0,
		failCount: 0
	}),

	computed: {
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.code
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		},

		filteredShops() {
			return this.shopList.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	mounted: async function() {
		await this.getBrands()
		await this.getShops()

		if (this.$route.params.id) {
			this.id = this.$route.params.id
			this.edit = true
			await this.getData(this.id)
		}
	},

	watch: {
		fileUpload: async function() {
			await this.importProducts()
		}
	},

	methods: {
		// To get total number of products in selected brand
		getData: async function(id) {
			const apiGetAdjustment = await this.$api.brandAdjustPriceList({
				data: { id, populate: ['brand', 'shops'] }
			})

			if (apiGetAdjustment.data.count > 0) {
				const apiData = apiGetAdjustment.data.list[0]

				this.name = apiData.name
				this.selectedBrand = apiData.brand
				this.shops = apiData.shops
				this.type = apiData.type
				this.value = apiData.value
				this.status = apiData.status
			}
		},

		// Update selected brand percentages
		submit: async function() {
			this.isLoading = true

			let data = {}

			if (!this.edit) {
				// Get total number of products
				data = {
					name: this.name,
					brand: this.selectedBrand._id,
					shops: this.shops,
					type: this.type,
					value: this.value,
					status: this.status
				}

				const apiBrandAdjust = await this.$api.brandAdjustPrice({ data })

				this.isLoading = false

				if (apiBrandAdjust) {
					this.$swal.fire({ icon: 'success', title: 'Success!', text: 'Price will be updated in a few minutes.' })
					this.$router.push({ name: 'brandPriceAdjustment' })
				}
			} else {
				// Get total number of products
				data = {
					id: this.id,
					name: this.name,
					type: this.type,
					value: this.value,
					status: this.status
				}

				console.log(data);
				
				// Update the settings
				const apiBrandAdjust = await this.$api.brandAdjustPriceUpdate({ data })

				console.log(apiBrandAdjust);

				this.isLoading = false

				if (apiBrandAdjust) {
					this.$swal.fire({ icon: 'success', title: 'Success!', text: 'Price will be updated in a few minutes.' })
					this.$router.push({ name: 'brandPriceAdjustment' })
				}
			}
			
		},

		getProductsLoop: async function(data) {
			return await this.$api.getProducts({ data })
		},

		confirmPercentage: async function() {
			if (this.percentage == '' || !this.selectedBrand) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Brand and Percentage are required!'
				})

				return
			}

			if (isNaN(this.percentage)) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Percentage can only be number'
				})

				return
			}

			if (this.percentage < 10) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Please check percentage value'
				})

				return
			}

			this.$swal
				.fire({
					title: this.selectedBrand.name + ' to ' + this.percentage + '%?',
					text: 'Are you sure you want to update?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes!'
				})
				.then(result => {
					if (result.value) {
						this.updatePercentage()
					}
				})
		},

		getBrands: async function() {
			const data = {
				limit: 2000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			if (apiGetBrands !== undefined) {
				this.brands = apiGetBrands.data.list
			}
		},
		// Import Shop Products
		importProducts: async function() {
			const data = {
				file: this.fileUpload._id
			}

			const apiImportShopProducts = await this.$api.importProduct({
				data
			})

			if (apiImportShopProducts !== undefined) {
				this.$swal.fire('Product Price are adjusted!')
			}
			this.isLoading = false
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shopList = apiGetShops.data.list
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
